module.exports = __webpack_public_path__ + "img/consulting-hero-bg.1e13dbad.svg";